import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRewardRoute } from '@/common/reward/route.registry';
import { InjectionFeature } from '@/common/reward/types';
import { registerRouteForModule } from '@/common/route/registerModules';
import { Role } from '@/modules/auth/types';
import router, { ROUTE_NAME_AVATAR } from './router';

export default registerRouteForModule(router);

registerRewardRoute(InjectionFeature.AvatarBundle, {
    routeToIndexPage: () => ({ name: ROUTE_NAME_AVATAR.BUNDLE.INDEX }),
    routeToInfoPage: bundleId => ({ name: ROUTE_NAME_AVATAR.BUNDLE.EDIT, params: { bundleId } })
});

registerRewardRoute(InjectionFeature.AvatarBackground, {
    routeToIndexPage: () => ({ name: ROUTE_NAME_AVATAR.BACKGROUND.INDEX }),
    routeToInfoPage: id => ({ name: ROUTE_NAME_AVATAR.BACKGROUND.EDIT, params: { id } })
});

menuRegistry.registerMenu([
    {
        parent: 'SystemWide',
        key: 'Avatar',
        name: 'Avatar',
        icon: 'fa fa-tshirt',
        roles: [Role.ADMIN]
    },
    {
        parent: 'SystemWide.Avatar',
        key: 'Background',
        name: 'Background',
        icon: 'fa fa-image',
        route: { name: ROUTE_NAME_AVATAR.BACKGROUND.INDEX }
    },
    {
        parent: 'SystemWide.Avatar',
        key: 'Category',
        name: 'Category',
        icon: 'fa fa-list-alt',
        route: { name: ROUTE_NAME_AVATAR.CATEGORY.INDEX }
    },
    {
        parent: 'SystemWide.Avatar',
        key: 'Item',
        name: 'Item',
        icon: 'fa fa-leaf',
        route: { name: ROUTE_NAME_AVATAR.ITEM.INDEX }
    },
    {
        parent: 'SystemWide.Avatar',
        key: 'Bundle',
        name: 'Bundle',
        icon: 'fa fa-box',
        route: { name: ROUTE_NAME_AVATAR.BUNDLE.INDEX }
    },
    {
        parent: 'SystemWide.Avatar',
        key: 'DefaultAvatar',
        name: 'Default Avatar',
        icon: 'fa fa-user-astronaut',
        route: { name: ROUTE_NAME_AVATAR.DEFAULT.INDEX }
    },
    {
        parent: 'SystemWide.Avatar',
        key: 'GenderAvatar',
        name: 'Gender Avatar',
        icon: 'fa fa-venus-mars',
        route: { name: ROUTE_NAME_AVATAR.GENDER }
    },
    {
        parent: 'SystemWide.Avatar',
        key: 'Color',
        name: 'Color',
        icon: 'fa fa-palette',
        route: { name: ROUTE_NAME_AVATAR.COLOR.INDEX }
    },
    {
        parent: 'SystemWide.Avatar',
        key: 'Layer',
        name: 'Layer',
        icon: 'fa fa-layer-group',
        route: { name: ROUTE_NAME_AVATAR.LAYER.INDEX }
    },
    {
        parent: 'SystemWide.Avatar',
        key: 'Import',
        name: 'Import',
        icon: 'fa fa-file-import',
        route: { name: ROUTE_NAME_AVATAR.IMPORT }
    }
]);
